import {
  ADD_PROJECT,
  DELETE_PROJECT,
  LIST_PROJECTS,
  SET_CONFIG_ENABLED,
  SET_CURRENT_PROJECT,
  SET_FILES
} from 'Actions/actionTypes'

export default (state = { projects: [], currentProject: undefined, files: [], displayConfigEnabled: false }, { payload, type }) ->
  switch(type)
    when LIST_PROJECTS
      { state..., projects: payload.data }
    when ADD_PROJECT
      { state..., projects: [...state.projects, payload] }
    when DELETE_PROJECT
      { state..., projects: state.projects.filter(({id})-> id isnt payload.id) }
    when SET_CURRENT_PROJECT
      { state..., currentProject: payload.data }
    when SET_FILES
      { state..., files: payload.data }
    when SET_CONFIG_ENABLED
      { state..., displayConfigEnabled: payload.data }
    else
      state
